import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { LIST_HEADER_ITEM_HEIGHT, LIST_ITEM_HEIGHT } from 'flow/flow-theme';
import { isContactKey, isEmptyNullOrUndefined, isExtensionKey, isThirdPartyContactKey } from 'flow/utils';

/** The item key of the central switch Overview, as its page opens it. */
export var CENTRAL_SWITCH_OVERVIEW_KEY = 'central-switch-overview';
export var contactListRowHeight = function contactListRowHeight(row) {
  return row.kind === 'sectionTitle' ? LIST_HEADER_ITEM_HEIGHT : LIST_ITEM_HEIGHT;
};
var entityRow = function entityRow(input, key) {
  if (isExtensionKey(key) && key !== input.ownExtensionKey) {
    return {
      kind: 'extension',
      entityKey: key
    };
  }
  if (isContactKey(key)) {
    return {
      kind: 'externalContact',
      entityKey: key
    };
  }
  if (isThirdPartyContactKey(key)) {
    return {
      kind: 'thirdPartyContact',
      entityKey: key
    };
  }
  return {
    kind: 'unknownKey',
    key: key
  };
};
var section = function section(input, title, rows) {
  var _ref = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
    _ref$sectionId = _ref.sectionId,
    sectionId = _ref$sectionId === void 0 ? title : _ref$sectionId,
    _ref$canToggle = _ref.canToggle,
    canToggle = _ref$canToggle === void 0 ? true : _ref$canToggle;
  var isOpen = canToggle ? input.sectionIsOpen(sectionId) : true;
  return [{
    kind: 'sectionTitle',
    sectionId: sectionId,
    title: title,
    isOpen: isOpen,
    canToggle: canToggle
  }].concat(_toConsumableArray(isOpen ? rows : []));
};
var keyRows = function keyRows(input, keys) {
  return keys.toArray().map(function (key) {
    return entityRow(input, key);
  });
};
var departmentRows = function departmentRows(input, department, extensionKeys) {
  // An empty name falls back to "No department"; an undefined one does not.
  var title = department || department !== '' ? department : input.translate('extensionlist.nodepartment');
  var otherColleagues = extensionKeys.filter(function (extensionKey) {
    return extensionKey !== input.ownExtensionKey;
  }).toList();
  return section(input, title, keyRows(input, otherColleagues));
};
var FAVORITES_SECTION_ID = 'favorites';
var asFavorite = function asFavorite(row) {
  return 'entityKey' in row ? _objectSpread(_objectSpread({}, row), {}, {
    isFavorite: true
  }) : row;
};
var favoriteRows = function favoriteRows(input) {
  return input.favoriteKeys.isEmpty() ? [] : section(input, input.translate('General.Favorites'), keyRows(input, input.favoriteKeys).map(asFavorite), {
    sectionId: FAVORITES_SECTION_ID
  });
};
var colleagueRows = function colleagueRows(input) {
  var extensionKeysByDepartment = input.extensionKeysByDepartment;
  var defaultGroup = extensionKeysByDepartment.get('');
  if (extensionKeysByDepartment.size <= 1 && defaultGroup) {
    return departmentRows(input, input.translate('colleagues'), defaultGroup);
  }
  return extensionKeysByDepartment.entrySeq().toArray().flatMap(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
      department = _ref3[0],
      extensionKeys = _ref3[1];
    return departmentRows(input, department, extensionKeys);
  });
};
var externalContactRows = function externalContactRows(input) {
  return !input.externalContactKeys || input.externalContactKeys.isEmpty() ? [] : section(input, input.translate('contacts.external'), keyRows(input, input.externalContactKeys));
};
var thirdPartyContactRows = function thirdPartyContactRows(input) {
  if (!input.connectedServicesAreOffered) {
    return [];
  }
  if (!input.hasSyncedSocialIntegrationAccount) {
    return section(input, input.translate('extensionlist.other'), [{
      kind: 'connectedServicesInstructions'
    }], {
      canToggle: false
    });
  }
  if (!input.thirdPartyContactKeys || input.thirdPartyContactKeys.isEmpty()) {
    return [];
  }
  return section(input, input.translate('extensionlist.other'), keyRows(input, input.thirdPartyContactKeys), {
    sectionId: 'extensionlist.other'
  });
};
var searchResultRows = function searchResultRows(input) {
  return input.searchResultKeys.isEmpty() ? [] : section(input, input.translate('search.results'), keyRows(input, input.searchResultKeys));
};
export var buildContactListRows = function buildContactListRows(input) {
  if (!isEmptyNullOrUndefined(input.searchText)) {
    return searchResultRows(input);
  }
  return [].concat(_toConsumableArray(input.showOverviewRow ? [{
    kind: 'centralSwitchOverview'
  }] : []), _toConsumableArray(favoriteRows(input)), _toConsumableArray(colleagueRows(input)), _toConsumableArray(externalContactRows(input)), _toConsumableArray(thirdPartyContactRows(input)));
};

// Names a row for the list: for react-window, the highlight and the Tab stop.
// A favourite is a row of its own, apart from the contact's copy in its
// department. So when the favourite is removed or Favourites is folded, the
// highlight goes with its row, and focus goes to the nearest row.
export var contactListRowKey = function contactListRowKey(row) {
  switch (row.kind) {
    case 'centralSwitchOverview':
      return row.kind;
    case 'sectionTitle':
      return "section:".concat(row.sectionId);
    case 'extension':
    case 'externalContact':
    case 'thirdPartyContact':
      return row.isFavorite ? "".concat(FAVORITES_SECTION_ID, ":").concat(row.entityKey) : row.entityKey;
    case 'unknownKey':
      return row.key;
    default:
      return null;
  }
};
export var rowIsFocusable = function rowIsFocusable(row) {
  switch (row.kind) {
    case 'centralSwitchOverview':
    case 'extension':
    case 'externalContact':
    case 'thirdPartyContact':
      return true;
    case 'sectionTitle':
      return row.canToggle;
    default:
      return false;
  }
};